import styled, { css } from 'styled-components'
import { Collapse as CollapseComponent, IconButton } from 'ui'

export const Container = styled.div<{ dragging: boolean }>`
    display: flex;
    margin-bottom: 10px;
    position: relative;

    &:last-child {
        margin-bottom: 0;
    }

    ${({ dragging }) =>
        dragging &&
        css`
            filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.3));
            z-index: 1;
        `}
`

export const Collapse = styled(CollapseComponent)`
    width: 100%;
`

export const DragButton = styled(IconButton)`
    cursor: grab;
    flex-shrink: 0;

    &:active {
        cursor: grabbing;
    }
`

export const Preview = styled.img`
    height: 34px;
    object-fit: contain;
    margin: 0 6px;
    max-width: 64px;
    pointer-events: none;
`

export const Duration = styled.span`
    flex-shrink: 0;
    margin: 0 6px 0 12px;

    &:only-child {
        margin: 0 auto;
    }

    span {
        color: rgba(255, 255, 255, 0.5);
    }
`

export const Title = styled.span`
    margin: 0 12px 0 6px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`
